import {
  ExternalContextSource,
  externalSourceComparator,
  getUniqueIdentifierForExternalSource,
} from "@hex/common";

import { ContextWorkbenchEditorFilesListNode } from "../contextWorkbenchEditorFilesListNode";
import { ContextWorkbenchFileNodeGroups } from "../contextWorkbenchFileNodeGroups";

export function getContextWorkbenchFileNodeGroups<
  Node extends { externalSource: ExternalContextSource | null },
>(
  nodes: Node[],
): ContextWorkbenchFileNodeGroups.FileNodeGroups<Omit<Node, "externalSource">> {
  const groups: Record<
    string,
    ContextWorkbenchFileNodeGroups.FileNodeGroup<Omit<Node, "externalSource">>
  > = {};
  for (const node of nodes) {
    const identifier = getUniqueIdentifierForExternalSource(
      node.externalSource,
    );

    let group = groups[identifier];
    group ??= {
      key: identifier,
      externalSource: node.externalSource,
      nodes: [],
    };
    const { externalSource: _, ...nodeWithoutExternalSource } = node;
    group.nodes.push(nodeWithoutExternalSource);
    groups[identifier] = group;
  }

  const orderedGroups = Object.values(groups).toSorted((a, b) =>
    externalSourceComparator(a.externalSource, b.externalSource),
  );

  return {
    type: ContextWorkbenchFileNodeGroups.Type.FileNodeGroups,
    groups: orderedGroups,
  };
}

export function getContextWorkbenchFileNodeGroupsAsyncPlaceholder(
  node: ContextWorkbenchEditorFilesListNode.AsyncPlaceholder,
): ContextWorkbenchFileNodeGroups.AsyncPlaceholder {
  return {
    type: ContextWorkbenchFileNodeGroups.Type.AsyncPlaceholder,
    node,
  };
}

export const getOnlyHasHexAuthoredGuides = (
  nodesBySource: ContextWorkbenchFileNodeGroups.FileNodeGroups<unknown>,
): boolean => {
  const identifier = getUniqueIdentifierForExternalSource(null);
  return (
    nodesBySource.groups.length === 1 &&
    !!nodesBySource.groups.some((group) => group.key === identifier)
  );
};
